export default __webpack_public_path__ + "../staticImages/sonne-260.png";